import { Component, Input} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';

/**
 * Generated class for the ComponentHeaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-component-header',
  templateUrl: 'component-header.html',
  inputs:['pagetitle']
})
export class ComponentHeaderPage {
  @Input() pagetitle: string;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }
  ngOnInit()
  {
    console.log(this.pagetitle);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ComponentHeaderPage');
  }

  home() {
    this.navCtrl.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/component-header/component-header.ts